import {ACTION_TYPES} from "./action-types";

const DEFAULT_STATE = {
    token: null,
    fastlane: null,
    canceledEmails: [],
    customerContextId: null
};

export default function reducer(state = DEFAULT_STATE, action) {
    let newState = state;

    switch (action.type) {
        case ACTION_TYPES.SET_FASTLANE:
            newState = {
                ...state,
                fastlane: action.fastlane
            }
            break;
        case ACTION_TYPES.SET_PAYMENT_TOKEN:
            newState = {
                ...state,
                token: action.token
            }
            break;
        case ACTION_TYPES.SET_CUSTOMER_CONTEXT:
            newState = {
                ...state,
                customerContextId: action.id
            }
            break;
        case ACTION_TYPES.ADD_CANCELED_EMAIL:
            newState = {
                ...state,
                canceledEmails: [...state.canceledEmails, action.email]
            }
            break;
    }
    return newState;
}